export default {
    namespaced: true,
    //状态
    state: {
        oldSearchData: "",
    },
    //方法
    actions: {

    },
    mutations: {
        updateSearchData(state, payload) {
            state.oldSearchData = payload
        }
    }

}